import type { Temporal } from "@js-temporal/polyfill";

export type SearchParamSerializer<T> = (param: T) => string | string[];

export const serializeBooleanSearchParam: SearchParamSerializer<boolean> = (
  param: boolean,
) => String(param);

export const serializeNumericSearchParam: SearchParamSerializer<number> = (
  param: number,
) => String(param);

export const serializeIntegerSearchParam: SearchParamSerializer<number> = (
  param: number,
) => String(Math.floor(param));

export const serializeDateSearchParam: SearchParamSerializer<Date> = (
  param: Date,
) => param.toISOString().slice(0, 10).replace(/-/g, "");

export const serializeDateTimeSearchParam: SearchParamSerializer<Date> = (
  param: Date,
) =>
  param
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}/, "");

export const serializeArraySearchParam =
  <T>(itemSerializer: SearchParamSerializer<T>): SearchParamSerializer<T[]> =>
  (items: T[]): string[] => {
    return items.map((item) => String(itemSerializer(item)));
  };

export const serializePlainTimeSearchParam: SearchParamSerializer<
  Temporal.PlainTime
> = (param: Temporal.PlainTime) => param.toString();

export const serializePlainDateSearchParam: SearchParamSerializer<
  Temporal.PlainDate
> = (param: Temporal.PlainDate) => param.toString();

export const serializePlainDateTimeSearchParam: SearchParamSerializer<
  Temporal.PlainDateTime
> = (param: Temporal.PlainDateTime) => param.toString();

export const serializeZonedDateTimeSearchParam: SearchParamSerializer<
  Temporal.ZonedDateTime
> = (param: Temporal.ZonedDateTime) => param.toString();
